import * as React from "react";
import * as LanguageTexts from "@genesys/shared/lib/language-texts";
import * as PropertiesSelector from "../../../../properties-selector";
import * as BuildingSettings from "../../../tools/moisture-load-rules/building-settings";
import { buildingDefs, buildingDefAdditional } from "../definitions";
import { FlexContainerCenter, StyledH3, Label } from "../local-elements";
import { InternalProps } from "../types";
import { Action } from "../state";
import { PropertyValueSet } from "@genesys/property";
import { ArrowDown, ArrowUp } from "@genesys/ui-elements";
import { createCustomRowRenderer } from "../ps-custom-row-renderer";

export function BuildingInfo(props: InternalProps) {
  const { sharedState, propertyDefinitions, renderPropertySelector } = props;
  return (
    <>
      <StyledH3>{sharedState.translate(LanguageTexts.mlcBuilding())}</StyledH3>
      <FlexContainerCenter>
        <img
          height="170"
          src="/assets/images/moisture-and-heat-load-types/building.jpg"
        />
        <div>
          {renderPropertySelector(
            buildingDefs(propertyDefinitions),
            undefined,
            "MoistureLoadTool.BuildingEditor"
          )}
        </div>
      </FlexContainerCenter>
    </>
  );
}

export function AddtionalBuildingInfo(props: InternalProps) {
  const {
    state,
    sharedState,
    propertyDefinitions,
    propertySelectorState,
    dispatch,
    renderPropertySelector,
    renderSystemOverride
  } = props;

  const currentSelections = PropertiesSelector.getSelectedProperties(
    propertySelectorState
  )!;
  const manualInputKey = BuildingSettings.manualInputProperty;

  const manualInputEnabled = !!(
    manualInputKey &&
    PropertyValueSet.getInteger(manualInputKey, currentSelections)
  );

  const defs = buildingDefAdditional(manualInputEnabled, propertyDefinitions);

  const systemOverride = manualInputEnabled
    ? renderSystemOverride(
        BuildingSettings.overridableProperties,
        "MoistureLoadTool.BuildingEditor"
      )
    : null;

  return (
    <>
      <div>
        <Label onClick={() => dispatch(Action.toggleAdditionalBuilding())}>
          {sharedState.translate(LanguageTexts.mlcBuildingExtended())}
          {state.isOpenAdditionalBuilding ? <ArrowUp /> : <ArrowDown />}
        </Label>
      </div>
      {state.isOpenAdditionalBuilding && (
        <div>
          {renderPropertySelector(
            defs,
            createCustomRowRenderer(manualInputKey, systemOverride),
            "MoistureLoadTool.BuildingEditor"
          )}
        </div>
      )}
    </>
  );
}
